<template>
	<page-content-layout class="invoicing" title="Afventende ordrer">
		<button-view v-if="false" slot="tools" label="Opret" />
		<button-group-view v-if="false" slot="tools" :actions="[
			{
				label: 'Modtaget',
				value: 'received'
			},
			{
				label: 'Åben',
				value: 'open'
			},
			{
				label: 'Lukket',
				value: 'closed'
			}
		]" v-model="active" />
		<new-table-view ref="table" :columns="[
			{
				label: 'Oprettet',
				name: 'created',
				filter: 'date',
				weight: 2
			},
			{
				label: 'Sendt til e-conomics',
				name: 'posted',
				weight: 2,
				filter: 'date'
			},
			{
				label: 'Fakturanr.',
				name: 'num',
				weight: 2
			},
			{
				label: 'Kunde',
				name: ['customer', 'name'],
				weight: 3
			},
			{
				label: 'Beløb',
				name: ['_calculated', 'total'],
				align: 'right',
				filter: 'number',
				weight: 2
			},
			{
				label: 'Bemærkninger',
				name: 'remarks',
				weight: 5
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				}
			}
		]" :items="_items" @itemClick="itemClick" @context="itemContext" />
	</page-content-layout>
</template>

<script>
	import Window from '../windows/ClaimWindow'
	import MailWindow from '../windows/MailWindow'
	import TextWindow from '../windows/TextWindow'
	import EmployeeHistoryWindow from '../windows/EmployeeHistoryWindow'
	import NewTableView from '../views/NewTableView'
	import ContextPopupView from '../views/ContextPopupView'

	import MoveTaskModel from '../model/MoveTask'
	import MoveTaskWindow from '../windows/MoveTaskWindow'

	import OrderModel from '../model/Order'
	import OrderWindow from '../windows/OrderWindow'

	import OrderMixin from '../../mixins/OrderMixin';

	import NewInvoiceWindow from '../windows/NewInvoiceWindow';
	import InvoiceModel from '../model/Invoice'

	import { bus } from '../../bus'

    export default {
		mixins: [ OrderMixin ],
		data() {
			return {
				items: [],
				active: 'received'
			};
		},
		components: {
			newTableView: NewTableView
		},
		computed: {
			_items() {
				const self = this;

				return this.items?.map((val) => {
					val._calculated = {
						total: self.$_OrderMixin_total(val.order_lines)
					};

					return val;
				}) || []; 
			},
			_status() {
				return {
					received: 'Modtaget',
					open: 'Åben',
					closed: 'Lukket'
				};
			},
			_statusDesc() {
				return this._status;
			},
			_statusColors() {
				return {
					received: 'yellow',
					open: 'yellow',
					closed: 'green'
				};
			}
		},
		methods: {
			async update() {
				var self = this;

				self.items = null;

				await this.axios.put('/invoices/update/');

				this.axios
					.get('/invoices/ready/')
					.then(function (r) {
						self.items = r.data;

						
					});
			},
			async itemClick(item) {
				var self = this;

				const invoice = (await this.axios.get(`/invoices/${item.id}/`)).data;

				self.$store.state.windowStack.push(NewInvoiceWindow, {
					value: {
						entity: invoice
					}, 
					submit: async function (entity, doEmail, doPost) {
						// Save invoice here
						
						const m = await InvoiceModel.save(this.axios, entity, doEmail, doPost);

						// Close window
						self.$store.state.windowStack.pop();

						// Return model
						return m;
					}
				});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/claims/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			itemContext(item, event) {
				event.stopPropagation();

				

				var self = this;

				var actions = [
					{
						label: 'Udskriv',
						action: async function () {
							window.open(process.env.VUE_APP_API + 'invoices/' + item.id + '/print/?token=' + self.$store.state.auth);
						}
					},
					{
						label: 'Send e-mail',
						action: async function () {
							if (!confirm('Er du sikker på at du vil sende denne faktura kladde?')) return;
							await self.axios.post(`invoices/${item.id}/email`);
							//self.update();
						}
					},
					null,
					{
						label: 'Slet',
						enabled: item.num === null,
						action: async () => {
							if (!confirm('Er du sikker på at du vil slette denne kladde og returnere ordre(ne) til at være ufaktureret?')) return;
							await self.axios.delete(`invoices/${item.id}`);
							self.update();
						}
					}
				];

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
		},
		mounted: function () {
			this.axios.put('/activity/booking/');

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss">

</style>